import { UtilityModule } from "@/core/modules/utility/objects/UtilityModule";

import ExportEmployeeView from "./views/ExportEmployeeView.vue";

export const exportEmployee: UtilityModule = new UtilityModule("data", "ExportEmployee", "utility", ExportEmployeeView);
